export type LiveBufferMinutes = 1 | 3 | 5 | 10;

export const LIVE_BUFFER_MINUTES_KEY = 'ott_live_buffer_minutes';
export const LIVE_BUFFER_MINUTES_OPTIONS: LiveBufferMinutes[] = [1, 3, 5, 10];

export function getLiveBufferMinutes(): LiveBufferMinutes {
  const value = Number(localStorage.getItem(LIVE_BUFFER_MINUTES_KEY));
  return LIVE_BUFFER_MINUTES_OPTIONS.includes(value as LiveBufferMinutes)
    ? value as LiveBufferMinutes
    : 3;
}
